module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon04_hover.d531ea12.svg";